import type { AxiosInstance } from 'axios'

export const getBlogStatistics = (api: AxiosInstance) => () =>
  api.get('/v1.0/admin/blogs/statistics')
